module.exports = "/images/visa.svg";